module.exports = __webpack_public_path__ + "img/MC.9ce1d042.svg";